import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import HorizontalSlider from '../HorizontalSlider';
import { searchProducts } from '~graphql/queries';
import { Product, SearchableSortDirection } from '~types/api';
import { formatCurrency } from '~utils/formatter';
import { getPublicImageUrl } from '~utils/image';
import { calculatePrice } from '~utils/price';
import { useGraphql } from '~view/hooks/graphql';

const SaleProducts: React.FC<{ categories: string[] }> = ({ categories }) => {
  const [items, fetch] = useGraphql<Product[]>(
    searchProducts,
    (data) => data.searchProducts.items
  );

  const products = useMemo(
    () =>
      items?.filter(
        (product) =>
          product.copiedBrand &&
          product.collections?.items?.length &&
          product.collections.items[0]?.collection?.published !== false &&
          product.product_sale_wholesale_rate &&
          !product.out_of_stock
      ) ?? [],
    [items]
  );

  useEffect(() => {
    fetch({
      filter: {
        product_brand_id: { eq: process.env.REACT_APP_HOMULA_BRAND_ID },
        suspended: { ne: true },
        out_of_stock: { ne: false },
        product_public_status: { ne: '非公開' },
        or: categories.map((category) => ({
          product_category: { eq: category },
        })),
      },
      sort: {
        field: 'createdAt',
        direction: SearchableSortDirection.desc,
      },
    });
  }, [categories]);

  if (!products.length) {
    return null;
  }

  return (
    <div className="mb-5 p-5 bg-orange">
      <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap">
        <h5 className="mb-0 font-weight-bold">在庫限りのセールアイテム</h5>
        <Link style={{ textDecoration: 'underline' }} to="/sale">
          全て見る
        </Link>
      </div>
      <HorizontalSlider contentAlign="left">
        {products.map((product) => (
          <Link to={`/sale/${product.collections?.items?.[0]?.collection_id}`}>
            <div className="mr-2">
              <div
                className="border"
                style={{ position: 'relative', paddingTop: '100%' }}
              >
                <img
                  className="w-100 h-100"
                  style={{
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                  }}
                  src={getPublicImageUrl(
                    product?.imageKeys?.items?.[0]?.imageKey ?? undefined,
                    {
                      w: 300,
                      h: 300,
                    }
                  )}
                />
              </div>
              <div className="font-weight-bold text-center" translate="no">
                {product.copiedBrand?.brand_name}
              </div>
              <div className="text-center">
                <s className="mr-2 text-muted">
                  {formatCurrency(
                    calculatePrice(
                      product.product_retail_price ?? 0,
                      product.product_wholesale_rate ?? 0
                    )
                  )}
                </s>
                <span className="text-danger">
                  {formatCurrency(
                    calculatePrice(
                      product.product_retail_price ?? 0,
                      product.product_sale_wholesale_rate ??
                        product.product_wholesale_rate ??
                        0
                    )
                  )}
                  （{product.product_sale_wholesale_rate}%）
                </span>
                <br />
                <span className="text-black-50">
                  上代 {formatCurrency(product.product_retail_price)}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </HorizontalSlider>
    </div>
  );
};

export default SaleProducts;
